import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Award, Target, Users, Zap } from "lucide-react";

const AboutPage = () => {
  const values = [
    {
      icon: Target,
      title: "رؤيتنا",
      description: "أن نكون الخيار الأول للشركات الناشئة والمؤسسات في مجال الاستضافة والتسويق الرقمي"
    },
    {
      icon: Award,
      title: "جودة عالية",
      description: "نلتزم بتقديم خدمات عالية الجودة تفوق توقعات عملائنا"
    },
    {
      icon: Users,
      title: "فريق محترف",
      description: "فريق من الخبراء المتخصصين في مجالات الاستضافة والتطوير والتسويق"
    },
    {
      icon: Zap,
      title: "ابتكار مستمر",
      description: "نواكب أحدث التقنيات والحلول في عالم التكنولوجيا"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-950 via-neutral-900 to-neutral-950">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-20">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            className="text-center max-w-3xl mx-auto"
          >
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              من نحن
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              Power Hosting هي شركة رائدة في مجال الاستضافة والتسويق الرقمي. نقدم حلول متكاملة للشركات والأفراد لتحقيق النجاح الرقمي.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-neutral-950/50">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ x: -50, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl font-bold text-white mb-6">قصتنا</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                بدأنا رحلتنا في عام 2019 برؤية واضحة: تقديم خدمات استضافة وتسويق رقمي عالية الجودة بأسعار منافسة.
              </p>
              <p className="text-gray-300 leading-relaxed mb-4">
                على مدار السنوات، نمت Power لتصبح واحدة من أكثر مزودي الخدمات موثوقية في المنطقة، مع آلاف العملاء الراضين.
              </p>
              <p className="text-gray-300 leading-relaxed">
                نحن نفخر بتقديم دعم فني على مدار الساعة وحلول مخصصة تناسب احتياجات كل عميل.
              </p>
            </motion.div>

            <motion.div
              initial={{ x: 50, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              className="grid grid-cols-2 gap-6"
            >
              <div className="bg-white/5 backdrop-blur-sm rounded-lg p-6 border border-white/10">
                <div className="text-4xl font-bold text-red-400 mb-2">5+</div>
                <div className="text-gray-300">سنوات خبرة</div>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-lg p-6 border border-white/10">
                <div className="text-4xl font-bold text-red-400 mb-2">10K+</div>
                <div className="text-gray-300">عميل سعيد</div>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-lg p-6 border border-white/10">
                <div className="text-4xl font-bold text-red-400 mb-2">99.9%</div>
                <div className="text-gray-300">وقت التشغيل</div>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-lg p-6 border border-white/10">
                <div className="text-4xl font-bold text-red-400 mb-2">24/7</div>
                <div className="text-gray-300">دعم فني</div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold text-white mb-4">قيمنا</h2>
            <p className="text-xl text-gray-300">المبادئ التي نعمل بها</p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <motion.div
                key={index}
                initial={{ y: 20, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <Card className="bg-white/5 border-white/10 hover:bg-white/10 transition-all h-full">
                  <CardHeader>
                    <div className="p-3 bg-red-500/20 rounded-lg w-fit mb-4">
                      <value.icon className="h-6 w-6 text-red-400" />
                    </div>
                    <CardTitle className="text-white">{value.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-gray-300">{value.description}</p>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
